<div class="wrapper">
  <div class="iw-signin-dialog">
    <div class="header iw-bold-18">
      <iw-logo />
    </div>

    <form class="body" [formGroup]="form" (ngSubmit)="reset()">
      <div class="content">
        <div class="text">
          <p
            class="title d-flex flex-col align-center text-center"
            translate="signin.tfaReset.header"
          ></p>
          <p class="message" translate="signin.tfaReset.message"></p>
        </div>

        <fu-simple-input
          [useOutlineLabel]="false"
          class="fu-form-container"
          formControlName="recoveryCode"
          [errorDictionary]="errorDictionary"
          [label]="'signin.tfaReset.control.code' | translate"
          placeholder="xxxxx - xxxxx"
        />

        <div class="footer-section">
          <div class="actions">
            <button
              type="submit"
              fuButton
              size="l"
              uiType="primary"
              translate="signin.tfaReset.btn.verify"
              [disabled]="!form.valid || isLoading"
            ></button>
            <div class="footer">
              <p class="footer-message">
                {{ "signin.tfaReset.help1" | translate }}
              </p>
              <a
                [href]="supportLink"
                target="_blank"
                translate="signin.tfaReset.help2"
                rel="noopener noreferrer"
              >
              </a>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</div>
